import { Alert, Button } from '@mui/material';
import { Company } from '@handover/shared-types';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { getCompanyAiState } from '../../helpers/companyAiHelper';

type AiUsageBannerProps = {
  company?: Company | null;
};

export const AiUsageBanner = ({ company }: AiUsageBannerProps) => {
  const location = useLocation();

  // Billing page already shows AI state in detail
  if (location.pathname.startsWith('/billing')) {
    return null;
  }

  const aiState = getCompanyAiState(company);

  // Only show usage-based alerts — trial/inactive alerts are handled by WorkspaceBillingBanner
  if (
    !aiState.alertSeverity ||
    aiState.isTrial ||
    (!aiState.isUsageLimitReached && !aiState.isUsingGraceBuffer && aiState.usagePercent < 50)
  ) {
    return null;
  }

  return (
    <Alert
      severity={aiState.alertSeverity}
      sx={{ mb: 3, borderRadius: 2 }}
      action={
        <Button component={RouterLink} to="/billing" color="inherit" size="small">
          {aiState.isUsageLimitReached ? 'Buy More Credits' : 'Manage Usage'}
        </Button>
      }
    >
      {aiState.alertMessage}
    </Alert>
  );
};
